import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthContextProvider } from "../context/AuthContext";
import Navbar from "../components/Navbar";
import App from "./App";
import Scrapers from "./Scrapers";
import ProfilePage from "./ProfilePage";
import Projects from "./Projects";
import Models from "./Models";
import Project from "./Project";
// import Search from "./Search";

import Model from "./Model";
import Name from "./Name";
import Form from "./Form";

import SignIn from "./SignIn";
import NotFoundPage from "./NotFoundPage";

const Router = () => (
  <BrowserRouter>
    <AuthContextProvider>
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <Navbar />
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/form" element={<Form />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/project/:projectId/profile/:userId" element={<ProfilePage />} />
          {/* <Route path="/search/:projectId" element={<Search />} /> */}
          <Route path="/users" element={<Projects />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/projects/:projectId" element={<Project />} />
          <Route path="/projects/:projectId/users/:nameId" element={<Name />} />
        </Routes>
        <footer className="footer footer-center pt-2 bg-neutral text-neutral-content mt-auto">
          <aside>
            <p className="footer-title">{process.env.REACT_APP_ENV}</p>
          </aside>
        </footer>
      </div>
    </AuthContextProvider>
  </BrowserRouter>
);

export default Router;
